// Platform commission rates are percentages of a sale: 0-100, at most two
// decimals (DECIMAL(5,2); CHECK partners_default_commission_rate_range).

export const DEFAULT_COMMISSION_RATE = 20;

/** Parse a commission-rate input. Returns { value } or { error }. */
export function parseCommissionRate(input) {
  const text = String(input ?? "").trim();
  if (text === "") return { error: "Enter a commission rate between 0 and 100" };
  if (!/^-?(\d+\.?\d*|\.\d+)$/.test(text)) {
    return { error: "Commission rate must be a number" };
  }
  const value = Number(text);
  if (value < 0 || value > 100) {
    return { error: "Commission rate must be between 0 and 100" };
  }
  if (/\.\d{3,}$/.test(text)) {
    return { error: "Commission rate can have at most two decimals" };
  }
  return { value };
}

/** The partner's stored default rate; an explicit 0 stays 0. */
export function partnerDefaultCommissionRate(partner) {
  const stored = partner?.default_commission_rate;
  return stored === null || stored === undefined || stored === ""
    ? DEFAULT_COMMISSION_RATE
    : Number(stored);
}
